import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import playIcon from '../Images/play.svg';
import playIconHover from '../Images/playHover.svg';
import pauseIcon from '../Images/pause.svg';
import pauseIconHover from '../Images/pauseHover.svg';
import soundOnIcon from '../Images/soundOn.svg';
import soundOnHoverIcon from '../Images/soundOnHover.svg';
import muteIcon from '../Images/mute.svg';
import muteIconHover from '../Images/muteHover.svg';

const VideoControls = ({ 
    isVideoPlaying, 
    isMuted, 
    hasCards,
    onPlayPause, 
    onToggleMute,
    showControls = true
}) => (
    <>
        <div className={`video-controls ${showControls ? 'visible' : ''}`}>
            <button 
                className="video-control video-play-pause center" 
                onClick={onPlayPause}
                data-state={isVideoPlaying ? 'playing' : 'paused'}
                aria-label={isVideoPlaying ? 'Pause video' : 'Play video'}
            >
                <Image className="icon-default" 
                    src={isVideoPlaying ? pauseIcon : playIcon} 
                    alt={isVideoPlaying ? 'Pause' : 'Play'} />
                <Image className="icon-hover" 
                    src={isVideoPlaying ? pauseIconHover : playIconHover} 
                    alt="" 
                    aria-hidden="true" />
            </button>
        </div>
        <button 
            className={`video-control video-mute bottom-left ${hasCards ? 'has-cards' : ''}`} 
            onClick={onToggleMute}
            data-state={isMuted ? 'muted' : 'unmuted'}
            aria-label={isMuted ? 'Unmute' : 'Mute'}
            style={{ position: 'absolute', left: '12px', bottom: '12px', zIndex: 40 }}
        >
            <Image className="icon-default" 
                src={isMuted ? muteIcon : soundOnIcon} 
                alt={isMuted ? 'Muted' : 'Sound on'} />
            <Image className="icon-hover" 
                src={isMuted ? muteIconHover : soundOnHoverIcon} 
                alt="" 
                aria-hidden="true" />
        </button>
    </>
);

export default VideoControls;
